import { MOBILE_HEADER_HEIGHT } from 'components/NavBar/NavBarMobile/constants';
import { cxTheme } from 'components/storybook-migration/theme-provider/system-design/theme';
import styled from 'styled-components';

export const MobileNavContainer = styled.div`
  ${({ theme }) => `
  display: flex;
  position: relative;
  flex-direction: row;
  align-items: center;
  background-color: ${theme.background.surface};
  justify-content: space-between;
  height: ${MOBILE_HEADER_HEIGHT}px;
  width: 100vw;
  box-shadow: ${theme.elevation.level0};
  padding: 12px;
  z-index: ${cxTheme.zIndex[5]};
  transition: transform 0.5s;
  `}
`;
